/**
 * ANTINORM — Audience-based Section Reorder || Added by PS on 5th June 2026
 * File: assets/custom-lp-reorder.js
 *
 * INSTALL:
 * 1. Upload this file to Assets/
 * 2. Add to theme.liquid just before </body>:
 *    <script src="{{ 'custom-lp-reorder.js' | asset_url }}" defer></script>
 *
 * HOW SECTION IDs WORK:
 * Shopify renders each section as:
 *   shopify-section-template--[templateId]__[sectionKey]
 * Find your templateId by inspecting any section div on the live product page.
 *
 * UTM PARAM: reads ?UTM-Misc= from the URL.
 * Example: /products/test-ps2?UTM-Misc=AudienceA
 *
 * LAYOUT LOOKUP ORDER (most specific → most general):
 * 1. "[handle]::[utm]"      — this product + this UTM value
 * 2. "[handle]::default"    — this product, no/unknown UTM
 * 3. "global::[utm]"        — any targeted product + this UTM
 * 4. "global::default"      — catch-all fallback
 * If none match, page is left completely untouched.
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════════════════
     PRODUCTS
     Map each product handle to its Shopify template ID.
     Find templateId by inspecting any section div on that product's page:
       <div id="shopify-section-template--21377147076746__main">
                                          └─ this number ──┘
  ════════════════════════════════════════════════════════════════════════ */
  var PRODUCTS = {
    'test-ps2': {
      templateIds: ['21377147076746', '21465199804554','21473177010314']
      // Add more templateIds here if this product appears in more theme copies
    }
    // 'facial-in-a-flash': { templateIds: ['XXXXXXXXXXXXXXX'] },
    // 'bye-bye-blow-dry':  { templateIds: ['XXXXXXXXXXXXXXX'] }
  };

  /* ════════════════════════════════════════════════════════════════════════
     LAYOUTS
     Key: "[handle]::[UTM-Misc value]"  or  "[handle]::default"

     Value: full ordered array of section keys for that page.
     List ALL sections for this product in the order you want them.
     Any section key not listed will appear after the listed ones
     in its original DOM order.

     CONFIRMED SECTIONS ON test-ps2 (from DOM inspection):
       main                              Hero / product form        ← last in DOM by default
       typewrite_text_DYGrtz             Typewriter text
       faq_U9pe48                        FAQ
       product_ingredients_aGjypV        Ingredients
       17737460021280b3c5                (unnamed section)
       product_replacement_table_i3GiXe  Replacement table
       product_benefits_rK7nK4           Benefits
       product_before_after_rJfpgX       Before & after
       product_cards_4qh6Vp              Product cards
       1768205830da460ca5                Nector reviews widget
  ════════════════════════════════════════════════════════════════════════ */
  var LAYOUTS = {

    /* ── test-ps2 ──────────────────────────────────────────────────────── */

    // URL: /products/test-ps2?UTM-Misc=AudienceA
    'test-ps2::AudienceA': [
      'main',                             // 1. Hero
      '17737460021280b3c5',               // 5.
      'product_replacement_table_i3GiXe', // 6.
      'typewrite_text_DYGrtz',            // 2.
      'faq_U9pe48',                       // 3.
      'product_ingredients_aGjypV',       // 4.
      'product_benefits_rK7nK4',          // 7.
      'product_before_after_rJfpgX',      // 8.
      'product_cards_4qh6Vp',             // 9.
      '1768205830da460ca5'                // 10.
    ]

    // Add more layouts here as needed:
    // 'test-ps2::AudienceB': [ ... ],
    // 'test-ps2::default':   [ ... ],
    // 'facial-in-a-flash::AudienceA': [ ... ]

  };

  /* ════════════════════════════════════════════════════════════════════════
     ENGINE — no need to edit below this line
  ════════════════════════════════════════════════════════════════════════ */

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getUtmValue() {
    return new URLSearchParams(window.location.search).get('UTM-Misc') || 'default';
  }

  function resolveLayout(handle, utmValue) {
    var candidates = [
      handle  + '::' + utmValue,
      handle  + '::default',
      'global::' + utmValue,
      'global::default'
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (LAYOUTS[candidates[i]]) {
        log('Layout resolved: ' + candidates[i]);
        return LAYOUTS[candidates[i]];
      }
    }
    return null;
  }

  // Detect which templateId is actually in the DOM for this page load
  function resolveTemplateId(templateIds) {
    for (var i = 0; i < templateIds.length; i++) {
      var prefix = 'shopify-section-template--' + templateIds[i] + '__';
      if (document.querySelector('[id^="' + prefix + '"]')) {
        log('Template ID found: ' + templateIds[i]);
        return templateIds[i];
      }
    }
    return null;
  }

  function reorderSections(layout, templateId) {
    var prefix = 'shopify-section-template--' + templateId + '__';

    var allSectionEls = Array.prototype.slice.call(
      document.querySelectorAll('[id^="' + prefix + '"]')
    );

    if (!allSectionEls.length) {
      warn('No sections found with prefix: ' + prefix);
      return;
    }

    var parent = allSectionEls[0].parentElement;

    var layoutIds = layout.map(function (key) {
      return prefix + key;
    });

    // Split into: sections explicitly ordered vs remaining
    var specified = [];
    var remaining = [];

    allSectionEls.forEach(function (el) {
      if (layoutIds.indexOf(el.id) !== -1) {
        specified.push(el);
      } else {
        remaining.push(el);
      }
    });

    // Sort specified to match layout order
    specified.sort(function (a, b) {
      return layoutIds.indexOf(a.id) - layoutIds.indexOf(b.id);
    });

    var ordered = specified.concat(remaining);

    // Find the first non-section sibling after all sections
    // (could be footer or any element after the sections block)
    // We use this as a stable anchor point that never moves
    var lastSection  = allSectionEls[allSectionEls.length - 1];
    var anchorAfter  = lastSection.nextSibling;

    // Re-insert all sections in order, before the stable anchor
    // This keeps header above and footer below untouched
    ordered.forEach(function (el) {
      parent.insertBefore(el, anchorAfter);
    });

    log('Reorder complete. ' + specified.length + ' sections repositioned.');
  }

  function log(msg)  { console.debug('[Custom LP Reorder] ' + msg); }
  function warn(msg) { console.warn('[Custom LP Reorder] '  + msg); }

  function init() {
    var handle   = getProductHandle();
    var utmValue = getUtmValue();

    if (!handle) return;

    var product = PRODUCTS[handle];
    if (!product) {
      log('Not a targeted product: ' + handle);
      return;
    }

    var layout = resolveLayout(handle, utmValue);
    if (!layout) {
      log('No layout for ' + handle + '::' + utmValue + ' — page untouched.');
      return;
    }

    var templateId = resolveTemplateId(product.templateIds);
    if (!templateId) {
      warn('No matching templateId found in DOM for: ' + handle);
      return;
    }

    reorderSections(layout, templateId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
